import React from "react"
import { connect } from "react-redux"
import { Route, Switch } from "react-router-dom"

import AuthNavbar from "components/Navbars/AuthNavbar.js"
import Footer from "components/Footers/Footer.js"
import { ErrorPage } from "components"

import routes from "routes.js"

class CustomWrapper extends React.Component {
  render() {
    return (
      <>
        <div className="main-content" ref="mainContent">
          <AuthNavbar />
          {this.props.component}
        </div>
        <Footer transparent />
      </>
    )
  }
}

class Auth extends React.Component {
  componentDidMount() {
    document.body.classList.add("bg-chift")
  }

  componentWillUnmount() {
    document.body.classList.remove("bg-chift")
  }

  componentDidUpdate(e) {
    if (e.history.pathname !== e.location.pathname) {
      document.documentElement.scrollTop = 0
      document.scrollingElement.scrollTop = 0
      if (this.refs.mainContent) {
        this.refs.mainContent.scrollTop = 0
      }
    }
  }

  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views)
      }
      if (prop.layout === "/a") {
        const PropComponent = prop.component
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            render={() => <CustomWrapper component={<PropComponent />} />}
            key={key}
          />
        )
      }
      return null
    })
  }

  render() {
    return (
      <Switch>
        {this.getRoutes(routes)}
        <Route component={ErrorPage} />
      </Switch>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  }
}
export default connect(mapStateToProps, {})(Auth)
